import { Button, Checkbox, Form, Modal } from "semantic-ui-react";
import "./ParameterModal.css";
import { useCallback, useEffect, useState } from "react";
import { toast } from "../..";
import { getCountries, updateCountryInvolment } from "../../services/countriesService";
import { ICountry } from "../../models/country";
import "./InvolvedCountriesModal.css";

interface IProps {
    modalOpen: boolean;
    closeModal: () => void;
}

export const InvolvedCountriesModal = ({ modalOpen, closeModal }: IProps) => {
    const [countries, setCountries] = useState<ICountry[]>([]);
    const [loading, setLoading] = useState(false);

    const fetchCountries = useCallback(async () => {
        try {
            setLoading(true);
            const res = await getCountries();
            setCountries(res);
        } catch {
            toast("Error fetching involved countries", false, 3000);
        }
        setLoading(false);
    }, []);

    useEffect(() => {
        fetchCountries();
    }, [fetchCountries]);

    const handleUpdateCountry = async (guid: string) => {
        try {
            setLoading(true);
            await updateCountryInvolment(guid);
            toast("Involved country updated", true, 1000);
        } catch {
            toast("Error updating country", false, 3000);
        }
        setLoading(false);
    };

    return (
        <Modal
            className="involved-country-modal"
            open={modalOpen}
            onClose={() => closeModal()}
            size="small"
            closeOnDimmerClick={false}
        >
            <Modal.Header>Edit involved countries</Modal.Header>
            <Modal.Content>
                <Form>
                    {countries.map(country => (
                        <Form.Field key={country.id}>
                            <label>{country.name}</label>
                            <Checkbox
                                toggle
                                checked={country.isInvolvedInMaps}
                                onChange={() => {
                                    handleUpdateCountry(country.id);
                                    setCountries(prev =>
                                        prev.map(c =>
                                            c.id === country.id
                                                ? { ...c, isInvolvedInMaps: !c.isInvolvedInMaps }
                                                : c
                                        )
                                    );
                                }}
                                disabled={loading}
                            />
                        </Form.Field>
                    ))}
                </Form>
            </Modal.Content>
            <Modal.Actions>
                <Button onClick={() => closeModal()} content="Close" />
            </Modal.Actions>
        </Modal>
    );
};
